// The way in to saved website profiles (PF-19), small enough for the menu's shell: the sheet itself
// (forms, number pad, its styles) is its own chunk, fetched only when a player opens it. The offer
// shows on the results board and now and again in the menu, never blocking play, and never inside a
// distributor's frame (lib/account says when).
import { lazy, Suspense, useState } from 'react';
import type { AccountStart } from '../account/Account';
import { sayLater, shouldOffer } from '../lib/account';
import { useUi } from '../store/ui';
import { S } from '../strings';

const Sheet = lazy(() => import('../account/Account').then((m) => ({ default: m.AccountSheet })));

/** The account sheet, from its own chunk. */
export function AccountDoor({ start, onClose }: { start: AccountStart; onClose: () => void }) {
  return (
    <Suspense fallback={null}>
      <Sheet start={start} onClose={onClose} />
    </Suspense>
  );
}

/** Keep your profile: Save my profile, or Not now (the menu asks again in a few days). */
export function SaveOffer({ className = '' }: { className?: string }) {
  // re-read when the account changes (saved: the offer goes)
  useUi((s) => s.account);
  const [open, setOpen] = useState(false);
  const [later, setLater] = useState(false);
  // the sheet keeps its place in the tree when the offer goes (saved), so its last step stays up
  const offer = !later && shouldOffer();
  return (
    <>
      {offer && (
        <section className={`wh-board save-offer ${className}`} aria-labelledby="save-offer-band">
          <header className="wh-board__band">
            <h2 id="save-offer-band">{S.account.offer.band}</h2>
          </header>
          <div className="save-offer__body">
            <p>{S.account.offer.line}</p>
            <div className="btn-row">
              <button type="button" className="wh-btn wh-btn--carry wh-btn--md" onClick={() => setOpen(true)}>
                {S.account.offer.save}
              </button>
              <button
                type="button"
                className="wh-btn wh-btn--quiet wh-btn--md"
                onClick={() => {
                  sayLater();
                  setLater(true);
                }}
              >
                {S.account.offer.later}
              </button>
            </div>
          </div>
        </section>
      )}
      {open && <AccountDoor start="save" onClose={() => setOpen(false)} />}
    </>
  );
}
